<template>
    <div :class="[ 'menu', open ? 'open' : null ]">
        <div class="menu-content p__2 row">
            <div class="col-xs-12 col-md-5 row middle-xs pv__0 pb__2 pv-md__2">
                <div class="ph-xs__1 ph-sm__2">
                    <h3>{{ titleText }}</h3>
                    <p>{{ rankingTopicsDescriptionText }}</p>
                    <div class="pt__1 row center-xs start-sm">
                        <div class="col-xs-12 mb__1">
                            <button class="btn btn--primary btn--block" @click.prevent="$emit('select-all')">{{ selectAllText }}</button>
                        </div>
                        <div class="col-xs-12">
                            <button class="mh__0 btn btn--underline btn--underline__primary btn--block" @click.prevent="$emit('deselect-all')">{{ deselectAllText }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-7 selector-content">
                <div class="ph-xs__1 ph-sm__2">
                    <div class="section-header">
                        <h5>{{ rankingTopicsText }}</h5>
                        <p class="m__0">{{ descriptionText }}</p>
                    </div>
                    <div class="row">
                        <template v-for="topic in topics">
                            <div :key="`item-${topic.topic_id}`" class="col-xs-12 col-sm-4 pb__1">
                                <button
                                    :class="[ 'btn', 'btn--block', isSelected( topic.topic_id ) ? 'btn--primary' : 'btn--default' ]"
                                    @click="toggleSelect( topic.topic_id )"
                                >{{ topic.topic_name }}</button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <button class="menu-toggle" @click.prevent="open = !open"></button>
    </div>
</template>
<script>
import { orderBy } from 'lodash';

export default {
    props: {
        selected: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        topics() {
            return orderBy( rankingChart.topics, 'topic_name' );
        },
        titleText() {
            return scAtts.title;
        },
        descriptionText() {
            return scAtts.content;
        },
        selectAllText() {
            return selectAll;
        },
        deselectAllText() {
            return deselectAll;
        },
        rankingTopicsText() {
            return rankingTopics;
        },
        rankingTopicsDescriptionText() {
            return rankingTopicsDesc;
        }
    },
    data() {
        return {
            open: true
        }
    },
    methods: {
        isSelected( id ) {
            return this.selected.includes( id );
        },
        toggleSelect( id ) {
            if( this.isSelected( id ) ) {
                this.$emit( 'deselect', id );
            } else {
                this.$emit( 'select', id );
            }
        }
    }
}
</script>